module.exports = __webpack_public_path__ + "img/no-photo.5e1d3ec4.png";